// Boat_Status__c, the values Salesforce accepts.
//
// Confirmed against production: these five are the only values any of the
// 727,362 synced boats carries, and they were reviewed before this shipped.
//
//   Active      639,556        Destroyed     1,654
//   Sold         74,960        Inactive        940
//   Not in Use   10,181
//
// Sourced from data rather than from a field describe, which is the weaker of
// the two: data shows what Salesforce has accepted historically, a describe
// shows what it accepts now. Two things this list therefore cannot know -
// whether one of these has since been retired from the picklist, and whether a
// valid value exists that nobody has used yet. If a status ever starts failing
// to sync, re-check it against the describe before editing this list:
//
//   sf.Boat__c.describe() -> fields -> Boat_Status__c -> picklistValues
//
// A status the record already holds is always offered even if it is not here,
// so an unrecognized legacy value is never silently rewritten on save.

export const BOAT_STATUSES = [
  "Active",
  "Not in Use",
  "Sold",
  "Inactive",
  "Destroyed",
];

// Only Active means the vessel is covered. The rest are all "not on the water
// under this membership" in one way or another, which is what the panel warns
// about when the status is set on a membership's primary boat.
export const ACTIVE_BOAT_STATUS = "Active";

export function boatStatusOptions(currentValue) {
  const options = BOAT_STATUSES.map((value) => ({ value, text: value }));

  // A value already on the record that this list does not carry stays
  // selectable. Dropping it would blank the select and write the blank back
  // on the next save, losing a status nobody asked to change.
  if (currentValue && BOAT_STATUSES.indexOf(currentValue) === -1) {
    options.push({ value: currentValue, text: `${currentValue} (existing)` });
  }

  return options;
}
